import http from "@/api";

export const getWebsiteSetting = () => {
	return http.get<API.Response<API.SingleResult<API.WebsiteSetting>>>(`/settings/website`);
};

export const getTradingSetting = () => {
	return http.get<API.Response<API.SingleResult<API.TradingSetting>>>(`/settings/trading`);
};

export const getSignSetting = () => {
	return http.get<API.Response<API.SingleResult<API.SignSetting>>>(`/settings/sign`);
};

export const getRegistrationAgreementSetting = () => {
	return http.get<API.Response<API.SingleResult<API.RegistrationAgreementSetting>>>(`/settings/registrationAgreement`);
};

export const getAboutUsSetting = () => {
	return http.get<API.Response<API.SingleResult<API.AboutSetting>>>(`/settings/aboutUs`);
};

export const getCertificateSetting = () => {
	return http.get<API.Response<API.SingleResult<API.CertificateSetting>>>(`/settings/certificate`);
};

export const getHelpMeSetting = () => {
	return http.get<API.Response<API.SingleResult<API.HelpMeSetting>>>(`/settings/helpMe`);
};

export const getClauseSetting = () => {
	return http.get<API.Response<API.SingleResult<API.ClauseSetting>>>(`/settings/clause`);
};

export const getEventSetting = () => {
	return http.get<API.Response<API.SingleResult<API.EventSetting>>>(`/settings/event`);
};

export const getTradingDescriptionSetting = () => {
	return http.get<API.Response<API.SingleResult<API.TradingDescriptionSetting>>>(`/settings/tradingDescription`);
};

export const getOrderDescriptionSetting = () => {
	return http.get<API.Response<API.SingleResult<API.OrderDescriptionSetting>>>(`/settings/orderDescription`);
};

export const getUseDescriptionSetting = () => {
	return http.get<API.Response<API.SingleResult<API.UseDescriptionSetting>>>(`/settings/useDescription`);
};

export const getPointsSetting = () => {
	return http.get<API.Response<API.SingleResult<API.PointsSetting>>>(`/settings/points`);
};

export const getTaskSetting = () => {
	return http.get<API.Response<API.SingleResult<API.TaskSetting>>>(`/settings/tasks`);
};

export const getNoticeSetting = () => {
	return http.get<API.Response<API.SingleResult<API.NoticeSetting>>>(`/settings/notice`);
};

export const getAwardDescriptionSetting = () => {
	return http.get<API.Response<API.SingleResult<API.AwardDescriptionSetting>>>(`/settings/awardDescription`);
};

export const getWorkBonusSetting = (params: any) => {
	return http.get<API.Response<API.SingleResult<API.WorkBonusSetting>>>(`/settings/workBonus`, params);
};

export const getEmailSetting = () => {
	return http.get<API.Response<API.SingleResult<API.EmailSetting>>>(`/settings/email`);
};

export const getPrivacyPolicySetting = () => {
	return http.get<API.Response<API.SingleResult<API.PrivacyPolicySetting>>>(`/settings/privacyPolicy`);
};

export const getLevelBonusSetting = () => {
	return http.get<API.Response<API.SingleResult<API.LevelBonusSetting>>>(`/settings/levelBonus`);
};

export const getErrorCodesSetting = () => {
	return http.get<API.Response<API.SingleResult<API.ErrorCodesSetting>>>(`/settings/errorCodes`);
};

export const getWalletsList = (params?: any) => {
	return http.get<API.Response<API.ListResult<API.WalletItem>>>(`/wallets/list`, params);
};
